import { render, staticRenderFns } from "./ConfiguracionInicial.vue?vue&type=template&id=19e0b05d"
import script from "./ConfiguracionInicial.vue?vue&type=script&lang=js"
export * from "./ConfiguracionInicial.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionInicial.vue?vue&type=style&index=0&id=19e0b05d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports